import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../../modules/shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaNumeroOcorrenciasDoDia = () => {
    const [totalOcorrenciasDoDia, setTotalOcorrenciasDoDia] = useState('')

    const buscaNumeroOcorrenciasDoDia = useCallback(() => {
        http.get('/ocorrencias-hoje', )
        .then(res => {
            const nrOcorrenciasHoje = res.data
            setTotalOcorrenciasDoDia(nrOcorrenciasHoje)
        })
        .catch(() => setTotalOcorrenciasDoDia(''))
    }, [])

    useEffect(() => {
        buscaNumeroOcorrenciasDoDia()
    }, [buscaNumeroOcorrenciasDoDia])

    useRecarregaAoRenovarToken(buscaNumeroOcorrenciasDoDia)

    return {
        totalOcorrenciasDoDia
    }
}
